import { Sparkles } from "lucide-react";
import type { MCPTool } from "../devAgentService";
import { QUICK_ACTIONS } from "./constants";

export function AgentFeedEmptyState({
  mcpTools,
  onQuickSend,
  sendDisabled,
}: {
  mcpTools: MCPTool[];
  onQuickSend: (query: string) => void;
  sendDisabled: boolean;
}) {
  return (
    <div className="flex flex-col items-center justify-center py-20 gap-6">
      <div className="text-center relative">
        <div className="absolute inset-0 -top-8 mx-auto w-24 h-24 bg-gradient-to-b from-blue-500/20 via-cyan-500/10 to-transparent rounded-full blur-2xl" />
        <Sparkles className="w-10 h-10 text-blue-400 mx-auto mb-3 relative animate-pulse" />
        <h2 className="text-lg font-semibold mb-1 relative">OrgCompass</h2>
        <p className="text-sm text-muted-foreground relative">
          Ask anything about your Salesforce org
        </p>
      </div>
      <div className="flex flex-wrap gap-2 justify-center max-w-lg">
        {QUICK_ACTIONS.map((a) => (
          <button
            key={a.label}
            type="button"
            onClick={() => onQuickSend(a.query)}
            disabled={sendDisabled}
            className="px-3 py-1.5 text-xs border border-border rounded-full hover:bg-muted/50 hover:border-blue-500/40 hover:shadow-[0_0_8px_rgba(59,130,246,0.15)] transition-all disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {a.label}
          </button>
        ))}
      </div>
      {mcpTools.length > 0 && (
        <div className="text-xs text-muted-foreground">
          {mcpTools.length} tools available
        </div>
      )}
    </div>
  );
}
